import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from 'axios';

import { getPropagatedHeaders } from './getPropagatedHeaders';

/**
 * A dedicated axios instance that forwards the configured propagation headers
 * from the incoming request onto every outbound request.
 *
 * Pass this as the third constructor argument to OpenAPI-generated service
 * clients (`new SomeApi(config, undefined, propagationAxios)`) so propagation is
 * scoped to our own service-to-service calls, which always run inside a request.
 * It deliberately does NOT touch the global default axios — that was the source
 * of the Apr 8 2026 incident, where the interceptor also wrapped background and
 * third-party calls running outside any request scope.
 */
export const propagationAxios: AxiosInstance = axios.create();

propagationAxios.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    const propagated = await getPropagatedHeaders();
    for (const [name, value] of Object.entries(propagated)) {
        // Only fill headers the caller (or dd-trace) hasn't already set, so we
        // never clobber a more accurate downstream context.
        if (config.headers.get(name) == null) {
            config.headers.set(name, value);
        }
    }
    return config;
});
